import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translationsLogbookEventCategoryClearState } from 'reducers/translations/logbookEventCategory/reducer'
import LogbookEventCategoryItem from './LogbookEventCategoryItem'
import LogbookEventCategoryList from './LogbookEventCategoryList'

function LogbookEventCategory(props) {
  const {
    match: {
      params: { id },
    },
    translationsLogbookEventCategoryClearState,
  } = props
  const LogbookEventCategoryContent = id
    ? LogbookEventCategoryItem
    : LogbookEventCategoryList

  useEffect(
    () => () => {
      translationsLogbookEventCategoryClearState()
    },
    [],
  )

  return (
    <div className="content">
      <LogbookEventCategoryContent {...props} />
    </div>
  )
}

LogbookEventCategory.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
  translationsLogbookEventCategoryClearState: PropTypes.func.isRequired,
}

export default connect(null, {
  translationsLogbookEventCategoryClearState,
})(LogbookEventCategory)
